import React from "react";

function SvgIcMapPoi023(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M14 13a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm8.5-1a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0122.5 12zM14 22a5.5 5.5 0 110-11 5.5 5.5 0 010 11m10.5-12h-5.507L17.75 8.011c-.25-.4-.75-.968-1.75-1.001A94.82 94.82 0 0014 7c-.91-.001-1.738.001-2 .01-1 .033-1.501.601-1.751 1.001L9.006 10H7.5A1.5 1.5 0 006 11.5v10A1.5 1.5 0 007.5 23h17a1.5 1.5 0 001.5-1.5v-10a1.5 1.5 0 00-1.5-1.5"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi023;
